import { createContext } from "react";

const schemedetail = {
    schemelist : '',
    setschemelist : ()=>{}
}

export const SchemeDetails = createContext(schemedetail)